import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BudgetSummary } from "@interfaces/budget-response";
import moment from "moment";

@Component({
  selector: "app-budget-mobile-card",
  templateUrl: "./budget-mobile-card.component.html",
  styleUrls: ["./budget-mobile-card.component.scss"]
})
export class BudgetMobileCardComponent {
  @Output() choose = new EventEmitter<void>();
  @Input() budget?: BudgetSummary;

  get numeroPedido() {
    return (budget?: BudgetSummary) =>
      `${moment(budget?.dataCriacaoObra).format("YYMMDD")}${budget?.idObra}`;
  }
}
